<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <core-card [actions]="[]">
      <div class="card-title w-100">
        <div [ngClass.xl]="'float-left'" [ngClass.sm]="'mb-075'" [ngClass.md]="'mb-075'">
          <input type="search" id="datatable-search-input" [placeholder]="'SEARCH' | translate" class="form-control" [(ngModel)]="searchKeyword" (ngModelChange)="billingFrequencyFilter()" />
        </div>
        <div class="float-right">
          <div [ngClass.xl]="'d-inline-block mr-2'" [ngClass.sm]="'d-none'" [ngClass.md]="'d-none'">
            <label class="d-flex align-items-center"
              >{{ "SHOW" | translate }}
              <select class="form-control ml-075 pr-3" (change)="updateTableLimit($event)">
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
            </label>
          </div>
          <a class="btn btn-outline-primary text-primary" (click)="modalOpen(modalBillingFrequencyAdd, null)" *ngIf="_authenticationService.hasCapability('create_billing_frequency')">{{ "ADD" | translate }}</a>
        </div>
        <div class="clearboth"></div>
      </div>
      <div class="card-body px-0 pb-0">
        <ngx-datatable
          class="bootstrap core-bootstrap"
          columnMode="force"
          [headerHeight]="30"
          [scrollbarH]="true"
          [messages]="{ emptyMessage: ('NO_DATA_TO_DISPLAY' | translate) }"
          [rowHeight]="_utilService.isDesktop ? 50 : 150"
          [limit]="tableLimit"
          [footerHeight]="50"
          [rows]="filteredBillingFrequencyList"
        >
          <ngx-datatable-column [name]="'NAME' | translate" prop="name" width="700" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span>{{ row.name }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'MONTH_VALUE' | translate" prop="other.month_value" width="200" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span>{{ row.other.month_value }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="{{ 'ACTIONS' | translate }}" [sortable]="false" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div>
                <button class="bg-transparent border-0 text-secondary pr-1" (click)="modalOpen(modalBillingFrequencyEdit, row)" *ngIf="_authenticationService.hasCapability('edit_billing_frequency')">
                  <i [data-feather]="'edit-2'" size="19"></i>
                </button>
                <button (click)="deleteBillingFrequency(row)" class="bg-transparent border-0 text-danger remove-item" *ngIf="_authenticationService.hasCapability('delete_billing_frequency')">
                  <i [data-feather]="'trash-2'" size="19"></i>
                </button>
              </div>
            </ng-template>
          </ngx-datatable-column>
          <!--mobile - tablet-->
          <ngx-datatable-column [name]="'NAME' | translate" prop="name" width="700" [sortable]="true" *ngIf="!_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="row list-item-mobile align-items-center">
                <div class="col-12">
                  <span class="font-weight-bold">{{ "NAME" | translate }}: </span>
                  <span>{{ row.name }}</span>
                </div>
                <div class="col-12">
                  <span class="font-weight-bold">{{ "MONTH_VALUE" | translate }}: </span>
                  <span>{{ row.other.month_value }}</span>
                </div>
                <div class="col-12 mt-075 text-right">
                  <div>
                    <button class="bg-transparent border-0 text-secondary pr-1" *ngIf="_authenticationService.hasCapability('edit_billing_frequency')" (click)="modalOpen(modalBillingFrequencyEdit, row)">
                      <i [data-feather]="'edit-2'" size="19"></i>
                    </button>
                    <button (click)="deleteBillingFrequency(row)" class="bg-transparent border-0 text-danger remove-item" *ngIf="_authenticationService.hasCapability('delete_billing_frequency')">
                      <i [data-feather]="'trash-2'" size="19"></i>
                    </button>
                  </div>
                </div>
              </div>
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
      </div>
    </core-card>
  </div>
</div>

<!-- Modal Edit -->
<ng-template #modalBillingFrequencyEdit let-modal>
  <div class="modal-header">
    <div></div>
    <button type="button" class="close" (click)="modal.close()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" tabindex="0">
    <h3>{{ "EDIT" | translate }} {{ "BILLING_FREQUENCY" | translate }}</h3>
    <div class="row">
      <div class="form-group col-12">
        <label [for]="'name'">{{ "BILLING_FREQUENCY" | translate }}<sup class="text-danger">*</sup></label>
        <input name="name" [(ngModel)]="billingFrequency.name" type="text" [id]="'name'" class="form-control" />
        <div class="font-error" *ngIf="showModalError && (!billingFrequency.name || billingFrequency.name.length < 1 || billingFrequency.name.trim() === '')">{{ "ERRORS.INSERT_BILLING_FREQUENCY" | translate }}</div>
      </div>
      <div class="form-group col-12">
        <label [for]="'month_value'">{{ "MONTH_VALUE" | translate }}<sup class="text-danger">*</sup></label>
        <input name="month_value" placeholder="Es. 1" [(ngModel)]="billingFrequency.other.month_value" type="number" [id]="'month_value'" class="form-control" />
        <div class="font-error" *ngIf="showModalError && (!billingFrequency.other.month_value || billingFrequency.other.month_value <= 0)">{{ "ERRORS.FIELD_MONTH_VALUE_MIN" | translate }}</div>
        <div class="font-error" *ngIf="showModalError && (!billingFrequency.other.month_value || billingFrequency.other.month_value > 12)">{{ "ERRORS.FIELD_MONTH_VALUE_MAX" | translate }}</div>
      </div>
    </div>
  </div>
  <div class="modal-footer d-flex justify-content-center">
    <button type="button" class="btn btn-outline-primary w-150" (click)="modal.close()" rippleEffect>
      {{ "ALERT.BTN_CANCEL" | translate }}
    </button>
    <button type="submit" class="btn btn-primary w-150" rippleEffect (click)="editBillingFrequency()">
      {{ "EDIT" | translate }}
    </button>
  </div>
</ng-template>
<!-- / Modal Edit -->

<!-- Modal Add -->
<ng-template #modalBillingFrequencyAdd let-modal>
  <div class="modal-header">
    <div></div>
    <button type="button" class="close" (click)="modal.close()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" tabindex="0">
    <h3>{{ "ADD" | translate }} {{ "BILLING_FREQUENCY" | translate }}</h3>
    <div class="row">
      <div class="form-group col-12">
        <label [for]="'name'">{{ "BILLING_FREQUENCY" | translate }}<sup class="text-danger">*</sup></label>
        <input name="name" [(ngModel)]="billingFrequency.name" type="text" [id]="'name'" class="form-control" />
        <div class="font-error" *ngIf="showModalError && (!billingFrequency.name || billingFrequency.name.length < 1 || billingFrequency.name.trim() === '')">{{ "ERRORS.INSERT_BILLING_FREQUENCY" | translate }}</div>
      </div>
      <div class="form-group col-12">
        <label [for]="'month_value'">{{ "MONTH_VALUE" | translate }}<sup class="text-danger">*</sup></label>
        <input name="month_value" placeholder="Es. 1" [(ngModel)]="billingFrequency.other.month_value" type="number" [id]="'month_value'" class="form-control" />
        <div class="font-error" *ngIf="showModalError && (!billingFrequency.other.month_value || billingFrequency.other.month_value <= 0)">{{ "ERRORS.FIELD_MONTH_VALUE_MIN" | translate }}</div>
        <div class="font-error" *ngIf="showModalError && (!billingFrequency.other.month_value || billingFrequency.other.month_value > 12)">{{ "ERRORS.FIELD_MONTH_VALUE_MAX" | translate }}</div>
      </div>
    </div>
  </div>
  <div class="modal-footer d-flex justify-content-center">
    <button type="button" class="btn btn-outline-primary w-150" (click)="modal.close()" rippleEffect>
      {{ "ALERT.BTN_CANCEL" | translate }}
    </button>
    <button type="submit" class="btn btn-primary w-150" rippleEffect (click)="addBillingFrequency()">{{ "SEND" | translate }}/{{ "ERRORS.INSERT" | translate }}</button>
  </div>
</ng-template>
<!-- / Modal Add -->
